<div class="container mt-4">
    <div class="row">
      <div class="col-md-4 col-12 mb-4">
        <div class="card shadow-sm">
          <div class="card-body">
            <h5 class="card-title">HCM Lineside</h5>
            <a href="#" class="btn bg-D20000">Launch</a>
          </div>
        </div>
      </div>
  
      <div class="col-md-4 col-12 mb-4">
        <div class="card shadow-sm">
          <div class="card-body">
            <h5 class="card-title">HCM Partsordering</h5>
            <a href="#" class="btn bg-D20000">Launch</a>
          </div>
        </div>
      </div>
  
      <div class="col-md-4 col-12 mb-4">
        <div class="card shadow-sm">
          <div class="card-body">
            <h5 class="card-title">HCM Conveyance</h5>
            <a href="#" class="btn bg-D20000">Launch</a>
          </div>
        </div>
      </div>
    </div>
  </div>